import React, { useState, useEffect, useRef }  from 'react';
import { HiArrowLeft } from "react-icons/hi2";
import {FaCamera} from "react-icons/fa";
import { Navbar, Button } from 'flowbite-react';
import ProfilePic from "../img/profile-pic.png";
import { useSearchParams, useNavigate } from "react-router-dom";
import "./styles.css"
import { MdCheckCircle } from "react-icons/md";
import { BsThreeDots } from "react-icons/bs";
import { handleImageUpload } from "./handler";

const ProfilePicture = (props) => {
  const cssForImageCard = {
    success : {
      imageDiv: 'mt-2 mb-10 custom-card-success border rounded-md items-center shadow-none p-10',
    },
    standard : {
      imageDiv: 'mt-2 mb-10 custom-card border rounded-md items-center shadow-none p-10',
    }
  }
  let [searchParams, setSearchParams] = useSearchParams();
  const selectedProfileType = JSON.parse(sessionStorage.getItem("selectedProfileType"));
  const navigate = useNavigate();
  const facialImageRef = useRef(null);
  let [validation, setValidation] = useState({ show: false , message: "", class:""});

  let [profilePhoto, setProfilePhoto] = useState();
  let [userUploadedProfilePic, setUserUploadedProfilePic] = useState(false)
  let [profilePicLoading, setProfilePicLoading] = useState(false)
  let [validationOnSubmit, setValidationOnSubmit] = useState(false)
  let [showSubmitButton, setShowSubmitButton] = useState(false)

  useEffect(()=>{
    for(let requiredItems of props.memberRequirement.requiredDocuments[props.itemIndex].requiredItems) {
      if (requiredItems.value !== "" && requiredItems.itemName === 'facialImage') {
        setProfilePhoto(requiredItems.url)
        setUserUploadedProfilePic(true)
      } else {
        setProfilePhoto(ProfilePic)
      }
    }
  }, [])

  const handleFacilaImageInputClick = () => {
    facialImageRef.current.click();
  }

  const handleFileChange = async (e, itemName) => {
    let file = e.target.files[0]
    if (!["image/png", "image/jpeg", "image/jpg"].includes(file.type) || file.size/1000000 > 7 ) {
     
        setValidation({ show: true , message: "Invalid image. Only images of type png, jpg, jpeg with size below 7mb can be uploaded", class:"error-msg"})
      return
    }
    setProfilePicLoading(() => true)
    await handleImageUpload(file, itemName, "profilePicture", 
    setProfilePhoto, setValidation, setUserUploadedProfilePic,
    setShowSubmitButton, props.memberRequirement,props.setMemberRequirement, props.itemIndex, navigate, selectedProfileType.profileId)
    setProfilePicLoading(() => false)
    
  }

  return (
    <>
    <Navbar
        fluid={true}
        rounded={true}
        className='shadow mb-3' style={{position:'fixed', width:'100%', top:'0'}}>
          
            <Navbar.Brand onClick={()=>{props.setOpenUploadDocument({openDocument : false , documentType : ""})}}>
             
                  <HiArrowLeft className='h-10 w-5 ml-2' />
             
            </Navbar.Brand>
          
        
      </Navbar>
    <div className='p-6  max-w-md m-auto' style={{paddingTop:'80px'}}>
        <h5 className="text-2xl mb-2 font-bold tracking-tight text-gray-900 dark:text-white">
          Profile Picture
        </h5>
        { validationOnSubmit && 
          <div className="error-msg">
            <span>Need to Upload Profile Picture before submitting for verification</span>
          </div>
        }

        {
          userUploadedProfilePic && 
          <div className="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white" style={{paddingRight: '10px'}}>
            <MdCheckCircle style = {{ color: '#15BE44' }}/>
          </div>
        }
        
        <label className='font-bold tracking-tight text-gray-900'>Image</label>
        <div  className={ userUploadedProfilePic ?  cssForImageCard.success.imageDiv : cssForImageCard.standard.imageDiv}>
        { validation.show &&
                  
                  <div className={ validation.class}>
                      <span >{validation.message}</span>
                  </div>
              
              }
                <img src={profilePhoto}
            className="w-auto m-auto"
            alt="Ryde" />
            <p className='text-xs text-gray-400 tracking-tight mt-2 ml-10'><i>• Ensure your face is visible. <br />
            • Remove Sunglasses. <br />
            • This will be in your public profile.</i></p>
            <div>
            
            <Button  pill={true} className='mt-5 m-auto w-sm pr-4' onClick={handleFacilaImageInputClick}>
            {
              profilePicLoading ? <BsThreeDots className="h-5 w-10" /> : <FaCamera className="h-5 w-10" />
            }
                    <label // for="file-upload" 
                    className="relative cursor-pointer rounded-md font-medium">
                      <span>{profilePicLoading ? 'Saving' : userUploadedProfilePic ? 'Replace' : 'Upload' }</span>
                      
                    </label> 
            </Button>
              <input id="file-upload" 
              name="file-upload" 
              type="file" 
              // class="sr-only" 
              ref={facialImageRef}
              style={{display: 'none', width:'0px',}}
              onChange={(event)=>{handleFileChange(event,"facialImage")}}

              />
            </div>
        </div>
        
        <Button className='bg-primary w-full mt-5' pill={true} disabled={false} onClick={()=>{
          if(userUploadedProfilePic ) {
            props.setOpenUploadDocument({
              openDocument: false,
              documentType: "",
            });
          } else {
            setValidationOnSubmit(true)
            window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
          }
        }}>
                    Save
                  </Button>
    </div>
   
    </>
  )
}

export default ProfilePicture;